import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactForm from "../../components/ContactForm";
import {Row} from "react-bootstrap";
import MotionDiv from "../motionDiv";

function ContactBlock() {
    return (
            <section id="contact" className="contact-section layout-pb-50 layout-pt-50">
                <div className="auto-container">
                    <Row>
                        <MotionDiv delay={0.3}>
                            <div className="sec-title">
                                <h2>
                                    <span>Contactez-nous</span> pour découvrir nos services
                                </h2>
                                <div className="text col-12">
                                    Un projet, une question ou simplement l’envie d’agir pour une société plus inclusive ?
                                </div>
                            </div>
                        </MotionDiv>

                        <MotionDiv delay={0.5} duration={0.5} variant={'toTop'}>
                            <div className="contact-form default-form">
                                <ContactForm/>
                            </div>
                        </MotionDiv>
                    </Row>
                </div>
            </section>
    )
}

export default ContactBlock;
